const EID_PARTY_EVENT_IDS = [
    process.env.NEXT_PUBLIC_EID_PARTY_1,
    process.env.NEXT_PUBLIC_EID_PARTY_2,
    process.env.NEXT_PUBLIC_EID_PARTY_3,
    process.env.NEXT_PUBLIC_EID_PARTY_4,
]

export const isEidPartyEvent = (eventId?: string): boolean => {
    if (!eventId) return false
    return EID_PARTY_EVENT_IDS.includes(eventId)
}

export const GOOGLE_PLAY_STORE_URL: string =
    "https://play.google.com/store/apps/details?id=com.starthub.passtickets"
export const APPLE_APP_STORE_URL: string =
    "https://apps.apple.com/us/app/pass-tickets/id1596912352"

export const DASHBOARD_URL: string = "https://dash.pass-tickets.com/"

// TODO: typically, rate limit duration should come from the server, but for now, we'll hardcode it here
export const OTP_RATE_LIMIT_DURATION = 900000; // 15 minutes in milliseconds
export const OTP_RATE_LIMIT_END_TIME_STORAGE_KEY = "rateLimitEndTime";
